import * as React from 'react';
import { useSetRecoilState } from 'recoil';
import RangeSelect from './RangeSelect';
import GroupSelect from './GroupSelect';
import DateRangePicker from './DateRangePicker';
import FilteredMultipleSelect from './FilteredMultipleSelect';
import SimpleInput from './SimpleInput';
import SimpleSelect from './SimpleSelect';
import Suggestion from './Suggestion';
import Default from './Default';
import { IHeadProps } from '../TableHead';
import { IDynamicTableState } from '../../../interfaces/tables';
import { setOpenedMenuName, tablesAtom } from '../../../store/recoil/TableState';

interface IComponentProps {
  label: boolean;
  action?: (title: string, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

type Props = IHeadProps & IComponentProps;

export default function Container({ ...props }: Props): JSX.Element {
  const setTables = useSetRecoilState<IDynamicTableState>(tablesAtom);

  const setOpenMenuName = (name: string, title: any, label: boolean, filter: any) => {
    setTables((oldState) => setOpenedMenuName(oldState, { name, title, filter, label: true }));
  };

  React.useEffect(() => {
    document.onkeydown = (event) => {
      const evt: any = event || window.event;
      if (evt.keyCode === 27 && props.columns) {
        setOpenMenuName(props.tableName, props.columns.name, props.label, null);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickOutside = (e: any) => {
    let areaElement = '';
    if (e.target.parentElement) {
      areaElement = e.target.parentElement.className;
    }

    if (
      (e.target.id !== 'reset' &&
        e.target.className !== 'd-block p-2' &&
        e.target.className !==
          'sibling-highlight cmd-icon cmd-icon-filter fs-3 text-gray text-decoration-none dropdown-toggle' &&
        e.target.className !==
          'sibling-highlight cmd-icon cmd-icon-filter fs-3 text-active text-decoration-none dropdown-toggle' &&
        e.target.id !== 'dropdownMenu13' &&
        e.target.id !== 'input-time' &&
        e.target.id !== 'input-time-to' &&
        e.target.className !== 'pl-5' &&
        e.target.type !== 'checkbox' &&
        e.target.className !== 'form-control font-weight-normal fs-2 filterMenu' &&
        e.target.className !== 'form-control font-weight-normal fs-2' &&
        e.target.className !==
          'cmd-icon cmd-icon-filter fs-3 text-gray text-decoration-none dropdown-toggle' &&
        e.target.className !==
          'cmd-icon cmd-icon-filter fs-3 text-active text-decoration-none dropdown-toggle' &&
        e.target.className !==
          'cmd-icon cmd-icon-lock-table fs-3 text-gray text-decoration-none dropdown-toggle' &&
        e.target.className !==
          'cmd-icon cmd-icon-lock-table fs-3 text-active text-decoration-none dropdown-toggle' &&
        e.target.className !== 'chosenItemsInfo' &&
        e.target.tagName !== 'SPAN' &&
        areaElement !== 'flatpickr-prev-month' &&
        areaElement !== 'flatpickr-next-month' &&
        areaElement !== 'scroll-area' &&
        areaElement !== 'form-group px-2' &&
        areaElement !== 'form-group px-2 mb-0' &&
        areaElement !== 'form-horizontal' &&
        areaElement !== 'dropdown-menu dropdown-menu-custom fs-2 js-dropdown-keep-open') ||
      areaElement === 'input-actions flatpickr-inline' ||
      areaElement === 'e-button dropdown-toggle ml-xs'
    ) {
      if (
        props.columns &&
        props.parentState.lastLabelClick &&
        props.filterComponent &&
        props.filterComponent.type === props.parentState.lastLabelClick &&
        props.filterComponent.active === true
      ) {
        props.reset(props.columns, props.parentState.lastLabelClick, false);
      }
      setOpenMenuName(props.tableName, props.columns?.name, props.label, null);
    }
  };

  React.useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  });

  switch (props.name) {
    case 'dateRangePicker':
      return (
        <DateRangePicker
          activePaging={props.activePaging}
          activeRows={props.activeRows}
          activeSorting={props.activeSorting}
          action={props.action}
          label={props.label}
          columns={props.columns}
          filterComponent={props.filterComponent}
          stateStartMin={props.parentState.startMin}
          stateStartMax={props.parentState.startMax}
          stateMin={props.parentState.min}
          stateMax={props.parentState.max}
          parentState={props.parentState}
          stateValue={props.stateValue}
          actionOpen={props.actionOpen}
          setStateValue={props.setValue}
          actionSave={props.actionSave}
          reset={props.reset}
          menuNameOpen={props.openedMenuName}
        />
      );
    case 'filteredMultipleSelect':
      return (
        <FilteredMultipleSelect
          activePaging={props.activePaging}
          activeRows={props.activeRows}
          activeSorting={props.activeSorting}
          action={props.action}
          label={props.label}
          columns={props.columns}
          filterComponent={props.filterComponent}
          stateStartMin={props.parentState.startMin}
          stateStartMax={props.parentState.startMax}
          stateMin={props.parentState.min}
          stateMax={props.parentState.max}
          parentState={props.parentState}
          stateValue={props.stateValue}
          actionOpen={props.actionOpen}
          setStateValue={props.setValue}
          actionSave={props.actionSave}
          reset={props.reset}
          menuNameOpen={props.openedMenuName}
        />
      );
    case 'simpleInput':
      return (
        <SimpleInput
          activePaging={props.activePaging}
          activeRows={props.activeRows}
          activeSorting={props.activeSorting}
          action={props.action}
          label={props.label}
          columns={props.columns}
          filterComponent={props.filterComponent}
          parentState={props.parentState}
          stateValue={props.stateValue}
          actionOpen={props.actionOpen}
          setStateValue={props.setValue}
          actionSave={props.actionSave}
          reset={props.reset}
          menuNameOpen={props.openedMenuName}
        />
      );
    case 'simpleSelect':
      return (
        <SimpleSelect
          activePaging={props.activePaging}
          activeRows={props.activeRows}
          activeSorting={props.activeSorting}
          action={props.action}
          label={props.label}
          columns={props.columns}
          filterComponent={props.filterComponent}
          parentState={props.parentState}
          stateValue={props.stateValue}
          actionOpen={props.actionOpen}
          setStateValue={props.setValue}
          actionSave={props.actionSave}
          reset={props.reset}
          menuNameOpen={props.openedMenuName}
          tableName={props.tableName}
        />
      );
    case 'suggestion':
      return (
        <Suggestion
          activePaging={props.activePaging}
          activeRows={props.activeRows}
          activeSorting={props.activeSorting}
          action={props.action}
          label={props.label}
          columns={props.columns}
          filterComponent={props.filterComponent}
          stateStartMin={props.parentState.startMin}
          stateStartMax={props.parentState.startMax}
          stateMin={props.parentState.min}
          stateMax={props.parentState.max}
          parentState={props.parentState}
          stateValue={props.stateValue}
          actionOpen={props.actionOpen}
          setStateValue={props.setValue}
          actionSave={props.actionSave}
          reset={props.reset}
          menuNameOpen={props.openedMenuName}
        />
      );
    case 'rangeSelect':
      return (
        <RangeSelect
          activePaging={props.activePaging}
          activeRows={props.activeRows}
          activeSorting={props.activeSorting}
          action={props.action}
          label={props.label}
          columns={props.columns}
          filterComponent={props.filterComponent}
          stateStartMin={props.parentState.startMin}
          stateStartMax={props.parentState.startMax}
          stateMin={props.parentState.min}
          stateMax={props.parentState.max}
          parentState={props.parentState}
          stateValue={props.stateValue}
          actionOpen={props.actionOpen}
          setStateValue={props.setValue}
          actionSave={props.actionSave}
          reset={props.reset}
          menuNameOpen={props.openedMenuName}
        />
      );
    case 'groupSelect':
      return (
        <GroupSelect
          activePaging={props.activePaging}
          activeRows={props.activeRows}
          activeSorting={props.activeSorting}
          action={props.action}
          label={props.label}
          columns={props.columns}
          filterComponent={props.filterComponent}
          parentState={props.parentState}
          stateValue={props.stateValue}
          actionOpen={props.actionOpen}
          setStateValue={props.setValue}
          actionSave={props.actionSave}
          reset={props.reset}
          menuNameOpen={props.openedMenuName}
        />
      );
    default: {
      return (
        <Default
          actionOpen={props.actionOpen}
          menuNameOpen={props.openedMenuName}
          action={props.action}
          label={props.label}
          columns={props.columns}
          filterComponent={props.filterComponent}
        />
      );
    }
  }
}
